// Client delle API del negozio personale (backend/shops/router.py).
import { supabase } from './supabase';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const authHeaders = async () => {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const parse = async (res) => {
  let body = null;
  try { body = await res.json(); } catch (_) { /* risposta vuota */ }
  if (!res.ok) throw new Error(body?.detail || 'Operazione non riuscita');
  return body;
};

// Configurazione pubblica della vetrina. In caso di errore si usa il modello standard.
export const fetchPublicShop = async (crafterId) => {
  try {
    const res = await fetch(`${API_URL}/api/shops/crafter/${crafterId}`);
    if (!res.ok) return { active: false, can_customize: false };
    return await res.json();
  } catch (_) {
    return { active: false, can_customize: false };
  }
};

export const fetchMyShop = async () => {
  const res = await fetch(`${API_URL}/api/shops/me`, { headers: await authHeaders() });
  return parse(res);
};

export const saveMyShop = async (config) => {
  const res = await fetch(`${API_URL}/api/shops/me`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...(await authHeaders()) },
    body: JSON.stringify(config),
  });
  return parse(res);
};

// Statistiche del negozio (ultimi 7/30/90 giorni)
export const fetchMyShopStats = async (days = 30) => {
  const res = await fetch(`${API_URL}/api/shops/me/stats?days=${days}`, { headers: await authHeaders() });
  return parse(res);
};

// Tariffe di spedizione attive della bottega (pubbliche)
export const fetchPublicShipping = async (crafterId) => {
  const res = await fetch(`${API_URL}/api/shops/crafter/${crafterId}/shipping`);
  return parse(res);
};
